import { css } from '@emotion/react'
import { gemVar, Spacing, ThemedColors, Typography } from '@opallabs/gem'

// Workaround for Blink rendering bug
// `overflow` on absolutely-positioned elements with `max-height`
// causes children to be rendered blurry
export const menuContent = css({
  height: '100%',
  overflowY: 'auto',
  display: 'flex',
  flexFlow: 'column nowrap',
  rowGap: Spacing.XS,
  padding: Spacing.XS,
  margin: 0,
})

/**
 * The mark at the end of an option. On the chosen option it is drawn in the
 * link colour, the way the design's check is, whatever the row's text is set
 * in; elsewhere it takes the row's ink.
 */
export const trailingNode = ({ selected }: { selected: boolean }) =>
  css({
    alignItems: 'center',
    color: selected ? gemVar(ThemedColors.IconLinks) : 'inherit',
    display: 'inline-flex',
  })

export const noOptions = css({
  padding: Spacing.S,
  textAlign: 'center',
  ...Typography.T500,
})
